import React from 'react';
import { Countdown } from './Countdown';
import { TrustBadges } from './TrustBadges';
import { FadeIn } from './FadeIn';
import { ChevronRightIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[100svh] flex flex-col justify-center items-center px-4 py-6 overflow-hidden" data-id="element-74">
      {/* Background court lines effect */}
      <div className="absolute inset-0 opacity-10 pointer-events-none flex justify-center" data-id="element-75">
        <div className="w-full max-w-5xl h-full border-x-2 border-padel-lime relative" data-id="element-76">
          <div className="absolute top-1/2 left-0 right-0 border-t-2 border-padel-lime" data-id="element-77"></div>
          <div className="absolute top-1/4 left-1/2 bottom-1/4 border-l-2 border-padel-lime" data-id="element-78"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-79">
        <FadeIn data-id="element-80">
          <span className="inline-block bg-padel-surface border border-padel-muted text-gray-300 text-[10px] sm:text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-3" data-id="element-81">
            Stock Digital™
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-82">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black text-white mb-2 leading-[0.95] tracking-tight uppercase text-balance" data-id="element-83">
            Resolvé todo tu año de pádel.{' '}
            <span className="text-padel-lime drop-shadow-[0_0_30px_rgba(197,255,61,0.3)]" data-id="element-84">
              Listo.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-85">
          <p className="text-lg sm:text-2xl md:text-3xl font-display font-bold text-padel-lime mb-3 uppercase tracking-tight" data-id="element-86">
            Con el Método Pro-Pádel 360.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-87">
          <p className="text-sm sm:text-lg text-gray-300 font-medium mb-4 max-w-2xl mx-auto leading-snug text-balance" data-id="element-88">
            Si sos profe de pádel y todavía planificás tus clases el domingo a
            la noche, esto es para vos.
          </p>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/7Q9v28T32RSup37B572osS/ChatGPT_Image_13_jun_2026,_08_40_36_p.m..png" alt="Mockup del Método Pro-Pádel 360: la guía completa con 6 tomos y 6 bonos" className="w-auto max-h-[26vh] sm:max-h-[32vh] mx-auto mb-4 object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)]" data-id="element-90" />
        </FadeIn>

        <FadeIn delay={0.3} className="flex flex-col items-center gap-3 sm:gap-4 w-full" data-id="element-91">
          <Countdown data-id="element-92" />

          <a href="https://stock-digital-shop.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-padel-lime hover:bg-padel-limeHover text-padel-dark font-display font-black text-lg sm:text-2xl px-8 sm:px-10 py-4 sm:py-5 rounded-xl flex items-center justify-center gap-3 transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_30px_rgba(197,255,61,0.25)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-93">
            QUIERO MI PACK AHORA
            <ChevronRightIcon className="w-5 h-5 sm:w-7 sm:h-7" strokeWidth={3} data-id="element-94" />
          </a>

          <TrustBadges data-id="element-95" />
        </FadeIn>
      </div>
    </section>;
}